export function replaceInString(str: string, replacements: Record<string, string>): string {
  return Object.entries(replacements).reduce(
    (acc, [key, value]) => acc.replace(`{{${key}}}`, value),
    str
  );
}
